import {Camera, CameraPerspective, CONSTANTS, Fog, LightAmbiant, LightDirectional, Material, MaterialColor, MeshBox, MeshInclinedPlane, Node, QUATERNION, Skybox} from '../../index.js';

/**
 * Gets an Hypercube.js default camera.
 * @returns {Camera}
 */
function camera() {

    return cameraperspective();
}

/**
 * Gets an Hypercube.js default perspective camera.
 * @returns {CameraPerspective}
 */
function cameraperspective() {

    return new CameraPerspective('Hypercube.js - Defaults - cameraperspective()', {

        'angle': 50,
        'far': 256,
        'near': 0.1
    });
}

/**
 * Gets an Hypercube.js default ambiant color.
 * @returns {vector3}
 */
function colorambiant() {

    const intensity = 0.2;

    return [0.8 * intensity, 0.9 * intensity, 1.0 * intensity];
}

/**
 * Gets an Hypercube.js default fog.
 * @returns {Fog}
 */
function fog() {

    return new Fog(colorambiant(), 0, 16, 1.0);
}

/**
 * Gets an Hypercube.js default invisible fog.
 * @returns {Fog}
 */
function foginvisible() {

    return new Fog([1.0, 1.0, 1.0], Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, 0.0);
}

/**
 * Gets an Hypercube.js default ambiant light.
 * @returns {LightAmbiant}
 */
function lightambiant() {

    return new LightAmbiant('Hypercube.js - Defaults - lightambiant()', colorambiant());
}

/**
 * Gets an Hypercube.js default directional light.
 * @returns {LightDirectional}
 */
function lightdirectional() {

    return new LightDirectional('Hypercube.js - Defaults - lightdirectional()', [-0.8, -1.0, -0.4], [1.0, 1.0, 1.0]);
}

/**
 * Gets an Hypercube.js default material.
 * @returns {Material}
 */
function material() {

    return materialcolor();
}

/**
 * Gets an Hypercube.js default color material.
 * @returns {MaterialColor}
 */
function materialcolor() {

    const parameters = {

        'color': [1.0, 1.0, 1.0]
    };

    return new MaterialColor('Hypercube.js - Defaults - materialcolor()', parameters);
}

/**
 * Gets an Hypercube.js default cube mesh.
 * @returns {MeshBox}
 */
function meshcube() {

    const mesh = new MeshBox('Hypercube.js - Defaults - meshcube()', [1, 1, 1]);

    mesh.setmaterial(materialcolor());

    return mesh;
}

/**
 * Gets an Hypercube.js default inclined plane mesh.
 * @returns {MeshInclinedPlane}
 */
function meshinclinedplane() {

    const mesh = new MeshInclinedPlane('Hypercube.js - Defaults - meshinclinedplane()');

    mesh.setmaterial(materialcolor());

    return mesh;
}

/**
 * Gets an Hypercube.js default node.
 * @returns {Node}
 */
function node() {

    return new Node('Hypercube.js - Defaults - node()');
}

/**
 * Gets an Hypercube.js default camera node.
 * @returns {Node}
 */
function nodecamera() {

    const node = new Node('Hypercube.js - Defaults - nodecamera()');

    node.setcamera(camera());

    node.rotate(QUATERNION.fromeuler([

        -22.5 * CONSTANTS.RADIANS,
        45 * CONSTANTS.RADIANS,
        0 * CONSTANTS.RADIANS
    ]));

    node.translateself([0, 0, 16]);

    return node;
}

/**
 * Gets an Hypercube.js default root node.
 * @returns {Node}
 */
function noderoot() {

    const node = new Node('Hypercube.js - Defaults - noderoot()');

    node.addmesh(meshcube());

    return node;
}

/**
 * Gets an Hypercube.js default rotation.
 * @returns {quaternion}
 */
function rotation() {

    return QUATERNION.identity();
}

/**
 * Gets an Hypercube.js default skybox.
 * @returns {Skybox}
 */
function skybox() {

    return new Skybox('Hypercube.js - Defaults - skybox()', colorambiant());
}

/**
 * Gets an Hypercube.js default translation.
 * @returns {vector3}
 */
function translation() {

    return [0, 0, 0];
}

/**
 * Gets an Hypercube.js default up vector.
 * @returns {vector3}
 */
function vectorup() {

    return [0, 1, 0];
}

export {

    camera,
    cameraperspective,
    colorambiant,
    fog,
    foginvisible,
    lightambiant,
    lightdirectional,
    material,
    materialcolor,
    meshcube,
    meshinclinedplane,
    node,
    nodecamera,
    noderoot,
    rotation,
    skybox,
    translation,
    vectorup
};
